mutation signUpMutation($input: SignUpInput!) {
    signUp(input: $input) {
      user {
        id
      }
      authentificationToken
    }
  }